import { render, staticRenderFns } from "./information-preview.vue?vue&type=template&id=47bfe184&scoped=true&"
import script from "./information-preview.vue?vue&type=script&lang=js&"
export * from "./information-preview.vue?vue&type=script&lang=js&"
import style0 from "./information-preview.vue?vue&type=style&index=0&id=47bfe184&scoped=true&lang=css&"
import style1 from "./information-preview.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47bfe184",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VContainer } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VCol,VContainer,VRow})
